import { Box } from '@/components/ui/box'
import ItemsList from '@/pages/components/tasksApprovals/mainContent/list'
import { IApproval, ICompliance } from '@/types/tasksApprovals'

const AllTab = ({ approvals, tasks }: { approvals: IApproval[]; tasks: ICompliance[] }) => {
    return (
        <Box>
            <Box h="100%" overflow="auto">
                {tasks.length > 0 && <ItemsList items={tasks} type="tasks" />}
                {approvals.length > 0 && <ItemsList items={approvals} type="approvals" />}
            </Box>
        </Box>
    )
}

export default AllTab
